/** Extra crew on a service report (API: ReportParticipant). Ansvarlig utførende = rapportens avtale-felt executing_employee. */
export const reportParticipantsRole = [
  {
    id: "EXECUTOR",
    name: "EXECUTOR",
    value: "EXECUTOR",
    label: "Executor",
    title: "Executor",
  },
  {
    id: "OBSERVER",
    name: "OBSERVER",
    value: "OBSERVER",
    label: "Observer",
    title: "Observer",
  },
];
